import axiosClient from "../axiosClient";

const route = "api/subCompany";

export const getBankIraqiCompanies = async (params) => {
  const response = await axiosClient.get(`${route}/forBank`, {
    params: {
      ...params,
    },
  });

  return response;
};

export const createIraqiCompany = async (companyData) => {
  const organizationId = parseFloat(localStorage.getItem("organizationId"));
  try {
    const response = await axiosClient.post(`${route}`, {
      ...companyData,
      organizationId,
    });
    return response;
  } catch (error) {}
};

export const editBankIraqiCompany = async (
  updatedIraqiCompanyData,
  companyId
) => {
  const organizationId = parseFloat(localStorage.getItem("organizationId"));
  try {
    const response = await axiosClient.put(
      `${route}/${companyId}`,
      {
        ...updatedIraqiCompanyData,
        organizationId,
      },
      {
        headers: {
          "organization-id": organizationId,
        },
      }
    );
    return response;
  } catch (error) {}
};

// get subCompanies that deals with the bank.

export const getBankSubcompanies = async (searchParams) => {
  try {
    const response = await axiosClient.get(`${route}/subCompaniesByBank`, {
      params: {
        ...searchParams,
      },
    });

    return response;
  } catch (error) {}
};


